import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { LegalNoticeRoute } from "./legal-notice-page";
import { PasswordResetPage } from "./password-reset-page";
import "./app/styles.css";
import "./app/platform-native-v2.css";

const legalNotice = LegalNoticeRoute();
const passwordReset = window.location.pathname.replace(/\/+$/u, "") === "/reset-password";
const componentPreview = import.meta.env.DEV && window.location.pathname.replace(/\/+$/u, "") === "/component-preview";
const WorkflowComponentsPreview = import.meta.env.DEV ? lazy(() => import("./workflow-components-preview")) : null;
createRoot(document.getElementById("root")!).render(
  <StrictMode>{legalNotice ?? (passwordReset ? <PasswordResetPage /> : componentPreview && WorkflowComponentsPreview ? <Suspense fallback={null}><WorkflowComponentsPreview /></Suspense> : <App />)}</StrictMode>,
);
